import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const InformationCardWrapper = styled.div`
  background-color: ${props => props.type === 'warning' ? props.theme.colorWarningBackground : props.theme.colorBlueBackground};
  color: ${props => props.type === 'warning' ? props.theme.colorWarning : props.colorBlack};
  padding: 15px;
  border-radius: 3px;
`;

const InformationCard = ({ className, children, type = 'info' }) => {
  return (
    <InformationCardWrapper className={className} type={type}>
      {children}
    </InformationCardWrapper>
  );
};

InformationCard.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  type: PropTypes.string,
};

InformationCard.defaultProps = {
  children: null,
  className: null,
  type: 'info',
};

export default InformationCard;
